import script from './ChartingTubeLabelWarning.vue2.js';
import normalizeComponent from '../../../../../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';
import createInjector from '../../../../../../../../node_modules/vue-runtime-helpers/dist/inject-style/browser.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Pane",
    {
      staticClass: "ChartingTubeLabelingWarning",
      attrs: {
        title: _vm.title,
        isOpened: _vm.isOpened,
        footerButtonText: _vm.footer ? _vm.footer.label : undefined
      },
      on: {
        confirm: function($event) {
          return _vm.$emit("close")
        },
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "BasicCard",
        {
          staticClass: "ChartingTubeLabelingWarning__card",
          attrs: { cardStyle: "white-with-border-danger" }
        },
        [
          _c(
            "div",
            { staticClass: "text-center mb-5" },
            [
              _c("CircleDanger", {
                attrs: { viewBox: "0 0 18 18", height: "120", width: "120" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "WaypointDeviationReasonModal__heading-text mt-3"
                },
                [
                  _vm._v(
                    "\n        Please label tubes before proceeding\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ChartingTubeLabelingWarning__subheader mt-2" },
                [
                  _vm._v(
                    "\n        Please label all tubes with patient’s name, date of birth and date and time of collection\n      "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-9832981e_0", { source: "/** I feel like we need to improve the naming convention here */\n.background-green-25[data-v-9832981e] {\n  background-color: #F6FEF9;\n}\n.background-purple-50[data-v-9832981e] {\n  background-color: #F9F5FF;\n}\n.background-blue-25[data-v-9832981e] {\n  background-color: #F5F8FF;\n}\n.background-red-25[data-v-9832981e] {\n  background-color: #FFFBFA;\n}\n.background-orange-50[data-v-9832981e] {\n  background-color: #FFFAEB;\n}\n\n/** --------------------------- BRAND VARIABLES ---------------------------- **/\n/** ---------------------------- COLOR PALETTE ----------------------------- **/\n/** ------------------------- TEXT & ICON PALETTE -------------------------- **/\n/** ---------------------------- LINK PALETTE ------------------------------ **/\n/** --------------------------- BUTTON PALETTE ----------------------------- **/\n/** --------------------------- INPUT STYLES ----------------------------- **/\n/** ---------------------------- MAP STYLES ----------------------------- **/\n/** ---------------------------- TOAST STYLES ----------------------------- **/\n/* Bulma Utilities */\n/** dash-size (1: solid, 2: 2 on/2 off, 3: 8 on/8 off, 4: 16 on/16 off) */\n/**\n * * Dashed-border does not behave nicely with real borders, if using, do not\n * * use border.\n * */\n.ChartingTubeLabelingWarning__heading-text[data-v-9832981e] {\n  font-weight: 600;\n  font-size: 14px;\n}\n.ChartingTubeLabelingWarning__subheader[data-v-9832981e] {\n  font-weight: 400;\n}\n.ChartingTubeLabelingWarning__card[data-v-9832981e] {\n  margin: 0 16px;\n}\n\n/*# sourceMappingURL=ChartingTubeLabelWarning.vue.map */", map: {"version":3,"sources":["ChartingTubeLabelWarning.vue","/builds/caresend/deploy/ui-components/src/components/specific/portal/components/ItineraryWaypoint/components/ProcedureCharting/ChartingTubeLabelWarning.vue"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E,6EAA6E;AAC7E,4EAA4E;AAC5E,8EAA8E;AAC9E,oBAAoB;AACpB,yEAAyE;AACzE;;;IAGI;ACgCJ;EACA,gBAAA;ED9BE,eAAe;AACjB;ACgCA;ED7BE,gBAAgB;AAClB;AC+BA;ED5BE,cAAc;AAChB;;AAEA,uDAAuD","file":"ChartingTubeLabelWarning.vue","sourcesContent":["/** I feel like we need to improve the naming convention here */\n.background-green-25 {\n  background-color: #F6FEF9;\n}\n\n.background-purple-50 {\n  background-color: #F9F5FF;\n}\n\n.background-blue-25 {\n  background-color: #F5F8FF;\n}\n\n.background-red-25 {\n  background-color: #FFFBFA;\n}\n\n.background-orange-50 {\n  background-color: #FFFAEB;\n}\n\n/** --------------------------- BRAND VARIABLES ---------------------------- **/\n/** ---------------------------- COLOR PALETTE ----------------------------- **/\n/** ------------------------- TEXT & ICON PALETTE -------------------------- **/\n/** ---------------------------- LINK PALETTE ------------------------------ **/\n/** --------------------------- BUTTON PALETTE ----------------------------- **/\n/** --------------------------- INPUT STYLES ----------------------------- **/\n/** ---------------------------- MAP STYLES ----------------------------- **/\n/** ---------------------------- TOAST STYLES ----------------------------- **/\n/* Bulma Utilities */\n/** dash-size (1: solid, 2: 2 on/2 off, 3: 8 on/8 off, 4: 16 on/16 off) */\n/**\n * * Dashed-border does not behave nicely with real borders, if using, do not\n * * use border.\n * */\n.ChartingTubeLabelingWarning__heading-text {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.ChartingTubeLabelingWarning__subheader {\n  font-weight: 400;\n}\n\n.ChartingTubeLabelingWarning__card {\n  margin: 0 16px;\n}\n\n/*# sourceMappingURL=ChartingTubeLabelWarning.vue.map */","<template>\n  <Pane\n    class=\"ChartingTubeLabelingWarning\"\n    :title=\"title\"\n    :isOpened=\"isOpened\"\n    :footerButtonText=\"footer ? footer.label : undefined\"\n    @confirm=\"$emit('close')\"\n    @close=\"$emit('close')\"\n  >\n    <BasicCard\n      class=\"ChartingTubeLabelingWarning__card\"\n      cardStyle=\"white-with-border-danger\"\n    >\n      <div class=\"text-center mb-5\">\n        <CircleDanger\n          viewBox=\"0 0 18 18\"\n          height=\"120\"\n          width=\"120\"\n        />\n        <div class=\"WaypointDeviationReasonModal__heading-text mt-3\">\n          Please label tubes before proceeding\n        </div>\n        <div class=\"ChartingTubeLabelingWarning__subheader mt-2\">\n          Please label all tubes with patient’s name, date of birth and date and time of collection\n        </div>\n      </div>\n    </BasicCard>\n  </Pane>\n</template>\n\n<script lang=\"ts\">\nimport { PropType, defineComponent } from 'vue';\n\nimport CircleDanger from '@assets/icons/circle-danger.svg';\nimport Pane from '@components/alerts/Pane/Pane.vue';\nimport BasicCard from '@components/cards/BasicCard/BasicCard.vue';\nimport type { WorkflowItemModalButtonProps } from '@components/specific/portal/store/portal/workflow/model';\n\nexport default defineComponent({\n  name: 'ChartingTubeLabelWarning',\n  components: {\n    BasicCard,\n    CircleDanger,\n    Pane,\n  },\n  props: {\n    isOpened: {\n      type: Boolean,\n      required: true,\n    },\n    title: {\n      type: String,\n      default: 'Label tubes to proceed',\n    },\n    footer: {\n      type: Object as PropType<WorkflowItemModalButtonProps | undefined>,\n      default: undefined,\n    },\n  },\n  emits: ['close'],\n  setup: () => ({}),\n});\n</script>\n\n<style lang=\"sass\" scoped>\n.ChartingTubeLabelingWarning__heading-text\n  font-weight: $cs-font-weight-semi-bold\n  font-size: 14px\n\n.ChartingTubeLabelingWarning__subheader\n  font-weight: $cs-font-weight-regular\n\n.ChartingTubeLabelingWarning__card\n  margin: 0 16px\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-9832981e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__ as default };
